import { usd, fecha } from "./util";

const R = 80, C = Math.PI * R; // semicírculo

export const Medidor = ({ d }) => {
  const l = d.linea || {};
  const total = l.total || 0, deuda = l.usado || 0, pedido = l.pedido_pendiente || 0;
  const p = total ? Math.min(100, (deuda / total) * 100) : 0;
  const pp = total ? Math.min(100, ((deuda + pedido) / total) * 100) : 0;
  const excede = total > 0 && deuda + pedido > total;
  const neto = l.disponible_neto ?? (total ? total - deuda - pedido : null);
  const arco = "M 20 100 A 80 80 0 0 1 180 100";
  return (
    <section className="rs-panel izq rg-sec" data-testid="resumen-panel-linea">
      <h3>Línea de crédito</h3>
      {!total ? <p className="rs-vacio">Sin línea registrada.</p> : (
        <>
          <div className="rg-med-wrap">
          <svg viewBox="0 0 200 112" className="rg-medidor" role="img" aria-label={`Línea usada ${Math.round(p)}%`}>
            <defs>
              <linearGradient id="rg-grad" x1="0" x2="1"><stop offset="0" stopColor="#2E9A5E" /><stop offset=".55" stopColor="#D2A23A" /><stop offset="1" stopColor="#E07A62" /></linearGradient>
            </defs>
            <path d={arco} stroke="#33402F" strokeWidth="14" fill="none" strokeLinecap="round" />
            <path d={arco} stroke="#7DBEE6" strokeWidth="4" fill="none" strokeDasharray="3 5" className="rg-traza" style={{ strokeDashoffset: C - (C * pp) / 100, "--largo": C }} strokeLinecap="round" opacity=".9" />
            <path d={arco} stroke="url(#rg-grad)" strokeWidth="14" fill="none" strokeLinecap="round" className="rg-traza" style={{ strokeDasharray: C, strokeDashoffset: C - (C * p) / 100, "--largo": C }} />
            {excede && <circle cx="180" cy="100" r="7" fill="#E07A62" className="rg-late" />}
          </svg>
          <div className="rg-med-txt rg-num" data-testid="resumen-linea-pct"><b>{`${p.toLocaleString("es-PY", { maximumFractionDigits: 1 })}%`}</b><small>LÍNEA USADA</small></div>
          </div>
          <div className="rs-minis rg-minis">
            <div className="rs-mini"><small>Línea</small><b>{usd(total)}</b>{l.adicionales > 0 && <p>{usd(l.base)} + {usd(l.adicionales)} adicional</p>}</div>
            <div className="rs-mini"><small>Deuda</small><b>{usd(deuda)}</b><p>disponible {usd(l.disponible)}</p></div>
            <div className="rs-mini"><small>Pedido pendiente</small><b style={{ color: "#7DBEE6" }}>{usd(pedido)}</b></div>
            <div className={`rs-mini ${neto !== null && neto < 0 ? "rg-roja" : ""}`} data-testid="resumen-linea-neto-caja"><small>Disponible neto</small><b data-testid="resumen-linea-neto">{usd(neto)}</b>{neto !== null && neto < 0 && <p>el pedido excede la línea</p>}</div>
          </div>
          {l.vencimiento && <p className="rg-nota">Línea vigente hasta {fecha(l.vencimiento)}</p>}
        </>
      )}
    </section>
  );
};
